module.exports = __webpack_public_path__ + "static/media/dl-front-example.b50e5b04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dl-front-example.svg
// module id = 205
// module chunks = 0